<template>
  <div class="contact-ec-cell">
    <template v-if="editStatus">
      <input
        v-model="checkBoxValue"
        :disabled="disabledCheckboxOnEdit"
        type="checkbox"
      >
      <span
        v-if="canAccess"
        class="icon-remove"
      >
        <i
          class="fa fa-times-thin"
          @click="deleteItem"
        />
      </span>
    </template>
    <template v-else>
      <span v-if="isUntickedOnRead">{{ $t('emptyValue') }}</span>
      <input
        v-else
        :checked="record.isVendorCircular"
        :disabled="true"
        type="checkbox"
      >
    </template>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  inject: [
    'getEdiStatus',
    'getUpdateAllContactsAccess',
  ],
  props: {
    record: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      privateValue: undefined,
    }
  },
  computed: {
    ...mapGetters('user', ['isContractorAdmin']),
    rawRecord () {
      return this.record.raw
    },
    isUntickedOnRead () {
      return !this.record.isVendorCircular && !this.editStatus
    },
    checkBoxValue: {
      get () {
        const isVendorCircular = this.record.isVendorCircular
        if (!this.editStatus) {
          return isVendorCircular
        }
        return this.privateValue !== undefined ? this.privateValue : isVendorCircular
      },
      set (value) {
        this.privateValue = value
        this.$emit('onChange', this.rawRecord.id, value)
      },
    },
    disabledCheckboxOnEdit () {
      return _.isEmpty(this.rawRecord.email)
    },
    editStatus () {
      return this.getEdiStatus()
    },
    canAccess () {
      return this.getUpdateAllContactsAccess()
    },
  },
  watch: {
    editStatus (value) {
      if (!value) this.privateValue = undefined
    },
  },
  methods: {
    deleteItem () {
      this.$emit('onDelete', this.rawRecord.ccdContact.id, this.rawRecord.id)
    },
  },
}

</script>

<style lang="scss" scoped>
@import '~styles/icon_remove';
.contact-ec-cell {
  text-align: center;
  .icon-remove {
    float: right;
    margin-top: -2px;
    padding: 0;
  }
}
</style>
